"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.settings.general': 'Generale',
    'route.settings.styles': 'Stili',
    'route.settings.access': 'Accessi',
    'route.settings.accessEdit': 'Modifica Accesso',
    'route.settings.accessAdd': 'Aggiungi Accesso',
    'route.settings.socialMediaPlan': 'Brand e Team',
    'route.settings.whatsapp': 'WhatsApp',
    'route.settings.whatsapp.manage': 'Gestisci numero WhatsApp',
    'route.settings.whatsappSettings': 'Numeri WhatsApp',
    'route.settings.whatsappSettings.create': 'Aggiungi numero WhatsApp',
    'route.settings.whatsappSettings.edit': 'Modifica numero WhatsApp',
};
